import React from 'react';

import EditIcon from 'Assets/icons/edit.svg';

const CLICKABLE_CATEGORIES = ['risk_type', 'impact', 'impact_category', 'probability', 'status'];

export default function GeneralRiskDefinitionsTableRow(props) {
    return (
        <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
            <td className="tw-align-top">
                {CLICKABLE_CATEGORIES.includes(props.definition.category) ? (
                    <span className="tw-underline tw-cursor-pointer" onClick={() => props.onCategoryClick(props.definition.category)}>
                        {props.definition.category_label}
                    </span>
                ) : (
                    props.definition.category_label
                )}
            </td>
            <td dangerouslySetInnerHTML={{ __html: props.definition.description }} onClick={props.onEdit} />
            <td>
                <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue" onClick={props.onEdit}>
                    <EditIcon className="tw-h-3" />
                    <div>{$t('Edit')}</div>
                </button>
            </td>
        </tr>
    );
}
